import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    DEFAULT_LEFT,
    SEARCH_MODEL
} from "../../../../../../../components/table/Model/TableModel";
import CustomTh from "../../../../../../../components/table/CustomTh";
import CustomTd from "../../../../../../../components/table/CustomTd";
import CustomImageTable from "../../../../../../../components/CustomImageTable";
import {
    DetailsIconsOptions,
    IconAvatarTable, IconClockTable, IconScheduleTable
} from "../../../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../../../components/CustomChip";
import {status, STATUS_MODEL} from "../../../../../../../enums/statusEnum";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../../../enums/statusColorEnum";
import DropDownMenuProfile from "../../../../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../../../../components/DropDown/DropDownMenuItem";
import {SimpleSearch} from "../../../../../../../reduxToolkit/Search/SearchApi";
import TableFunction from "../../../../../../../components/table/TableFunction";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    getDateFormat,
    getTimeFormat
} from "../../../../../../../Apis/functions";
import {ATTENDANCE_SUBVIEW_MODEL, NO_DEPARTMENT} from "../../../Model/Model";
import {useLocation, useNavigate} from "react-router-dom";
import {
    ATTENDANCE_SUBMISSION_HISTORY_MODEL, getSubmissionSearchType,
    handleSubmissionDetails
} from "../Model/Model";
import HandleChange from "../../../../../../../Helpers/HandleChange";
import {PERIOD_TIME_UNIT_ENUM} from "../../../../../../../enums/PeriodTimeUnitEnum";
import {permissionObj} from "../../../../../../../Helpers/permission";
import routes from "../../../../../../../Routes/routes";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack
 * @Email : kpozos@ibl.mx
 *
 */
const SubmissionHistoryTableApp = ({
    searchElement,
    setBodyForExport,
    option,
    modified,
    setModified
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const tableId = "tbl_sht_submission_history"; // Set the table ID for identification
    const [results, setResults] = useState({ content: [], totalElements: 0 }); // Store the search results
    const searchId = 'txt_sht_submission_history';
    const leftPosition = DEFAULT_LEFT;
    const startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);

    // Filters selected before opening a detail, so coming back keeps the same range.
    const restoredFilters = location?.state?.submissionHistoryFilters;
    const [item , setItem] = useState(() => ({
        ...ATTENDANCE_SUBMISSION_HISTORY_MODEL,
        startDate: startOfDay.getTime(),
        endDate: endOfDay.getTime(),
        ...restoredFilters
    }));
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const initFilters = useRef(false);
    const isAdmin = DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SUBMISSION_HISTORY_READ);
    // Row callbacks name their row "item" too, so the filters get their own reference.
    const filters = {
        departmentId: item?.departmentId,
        startDate: item?.startDate,
        endDate: item?.endDate
    };

    useEffect(() => {
        if (restoredFilters == null) return;
        // The filters were consumed, so they are dropped from the route state. Only that
        // key is removed: the tab and sub-view keys still drive the view on re-renders.
        const { submissionHistoryFilters, ...rest } = location.state;
        navigate(location.pathname, { replace: true, state: rest });
    }, []);

    useEffect(() => {
        if(!initFilters.current){
            initFilters.current = true;
            return;
        }
        setModified(true);
    }, [item]);

    const getThead = () => {
        return [
            isAdmin && <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('supervisor')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('period_type')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('from')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('to')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('created_at')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('headcount')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
        ];
    };

    const getTbody = () => {
        if (!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body = results?.content?.map((item) => {
            const approvalStatusId = item?.approvalStatusId;
            return (
                <>
                    {isAdmin && <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>
                        <CustomImageTable image={IconAvatarTable} containerClass={"d-flex align-items-center"} text={item?.requestedBy}/>
                    </CustomTd>
                    }
                    <CustomTd tableId={tableId}>
                        {`${item?.frequencyValueSnapshot} ${t(PERIOD_TIME_UNIT_ENUM[item?.frequencyTimeUnitSnapshot]?.trans)}`}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getDateFormat( item?.periodStartDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </div>
                        <div className={"d-flex"}>
                            <IconClockTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getTimeFormat(item?.periodStartDate)}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getDateFormat( item?.periodEndDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </div>
                        <div className={"d-flex"}>
                            <IconClockTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getTimeFormat(item?.periodEndDate)}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <div className={"d-flex"}>
                            <IconScheduleTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getDateFormat( item?.requestDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </div>
                        <div className={"d-flex"}>
                            <IconClockTable className={"mr-8px mb-1 icon-color-general-950"} />
                            {getTimeFormat(item?.requestDate)}
                        </div>
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.totalItems || EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip legend={t(status[approvalStatusId])}
                                    borderColor={statusBorderColor[approvalStatusId]}
                                    fontColor={statusFontColor[approvalStatusId]}
                                    background={statusColor[approvalStatusId]}
                                    variant={'large'}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body, // Return the generated table rows
            data: results?.content // Return the data associated with the rows
        };
    };

    const getActionsButtons = (item, index) => {
        return (
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`} // Unique menu ID for each contractor
            >
                <DropDownMenuItem
                    id={'btn_sht_details_' + item?.id}
                    index={index}
                    handleClose={handleClose}
                    name={t('details')}
                    click={() => handleSubmissionDetails(
                        `${routes.submission.historyDetails}${item?.id}`,
                        item,
                        navigate,
                        ATTENDANCE_SUBVIEW_MODEL.SUBMISSIONS.HISTORY,
                        filters
                    )}
                    icon={<DetailsIconsOptions />}
                />
            </DropDownMenuProfile>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { searchElement }) => {
        let attendanceSearchType = getSubmissionSearchType(item?.departmentId);

        const body = SEARCH_MODEL.setObject({
            page,
            size:rowsPerPage,
            model:option,
            key:searchElement,
            attendanceStartDate: new Date(item?.startDate)?.getTime(),
            attendanceEndDate: new Date(item?.endDate)?.getTime(),
            attendanceSearchType,
            modelId: item?.departmentId === NO_DEPARTMENT ? null: item?.departmentId
        })
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }

    // Use the TableFunction SubComponents to handle table logic (checkbox selection, pagination, etc.)
    const { thead,tbody, t, pagination, rowsPerPage,
        openMenu, handleMenuToggle, handleClose } = TableFunction({
        getTbody: getTbody,
        getThead: getThead,
        data: results,
        labelRowsPerPage: 'employees_per_page',
        hasContainer: true,
        fixedPagination: false,
        searchElement,

        getData,//New
        modified,
        setModified
    });

    return {
        t,
        dispatch,
        navigate,
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        item,
        handleChange,
        isAdmin
    };
};

export default SubmissionHistoryTableApp;
